import { getMatterList } from '@/matter/fetch/get-matter-list'
import { isSampleMatter } from './is-sample-matter'

export async function getCurrentUserSampleMatterId(): Promise<string | null> {
  const response = await getMatterList()
  return response.matters.find(isSampleMatter)?.id ?? null
}
